import { ProductBillingType } from "../Products";
import {
	VendorCompany,
	VendorIndustry,
	VendorSubscriptionStatus
} from "./Vendor";
import { MarketplaceProduct, MarketplaceCategory } from "./Product";
import { VendorPartnerTier } from "../Vendor/Tiers";

export enum MarketplaceCollection {
	JOINEDPROGRAM = "joined_program"
}

export enum MarketplaceCollectionRoute {
	JOINEDPROGRAM = "joined-programs"
}

export interface MarketplaceRouteParams {
	readonly collectionRoute: MarketplaceCollectionRoute;
}

export interface MarketplaceSubscriptionResponse {
	data: MarketplaceVendorSubscription[];
}

export interface UpdateClientSubscriptionsRequest {
	readonly clientId: string;
	readonly subscription: MarketplaceVendorSubscription;
}

export type RequestMarketplaceProductRequest = Record<string, string>;

export interface MarketplaceVendorSubscription {
	id: string;
	created: Date;
	updated: Date;
	active: boolean;
	effective_at: Date;
	renews_at: Date;
	vendor_company: VendorCompany; //to be changed
	partner_company_id: string;
	client_company_name: string;
	client_company_id?: string;
	usage_count: number;
	billed_amount: number;
	billing_period: ProductBillingType;
	vendor_product_id: string;
	vendor_product: Partial<MarketplaceProduct>;
	description: string;
}

export class CreateMarketplaceVendorReferralRequest {
	vendor_name = "";
	vendor_website = "";
	product_category = MarketplaceCategory.PRODUCTIVITY;
	constructor(
		vendorName: string,
		vendorWebsite: string,
		productCategory: MarketplaceCategory
	) {
		this.vendor_name = vendorName;
		this.vendor_website = vendorWebsite;
		this.product_category = productCategory;
	}
}

export class AcceptPartnerProgramInviteRequest {
	vendor_id = "";
	constructor(vendorId: string) {
		this.vendor_id = vendorId;
	}
}

export interface VendorInviteSignupMetadata {
	readonly logo: string;
	readonly name: string;
	readonly partner_domain_suffix?: string;
}

export class MyVendor {
	id = "";
	name = "";
	status: VendorSubscriptionStatus | null = null;
	initiated_at: Date | null = null;
	accepted_at: Date | null = null;
	industry: VendorIndustry | null = null;
	logo = "";
	tier_with_vendor: VendorPartnerTier | null = null;
}
export class MyVendorsCount {
	all = 0;
}

export class MyVendorsResponse {
	data: MyVendor[] = new Array<MyVendor>();
}

export class MyVendorsPaginationResponse {
	data: MyVendor[] = new Array<MyVendor>();
	filtered_count_map: MyVendorsCount = new MyVendorsCount();
}

export enum MyVendorsTabType {
	ALL_VENDORS = "all_vendors",
	MY_VENDORS = "my_vendors"
}
export enum MarketplaceComissionsTabType {
	COMMISSIONS = "commissions",
	TRANSACTIONS = "transactions"
}
